<template>
  <div>
    <v-row>
      <v-col cols="12" md="6">
        <v-hover v-slot="{ hover }">

          <v-card :style="{border: 'white'}"
                  :class="hover?'elevation-1 rounded-lg pa-5 glass-effect-hover':'elevation-1 rounded-lg pa-5 glass-effect'">
            <v-row>
              <v-card-title>
                <span class="white--text ml-2">{{ title }}</span>
                <supplier-select class="float-left" v-model="supplier"></supplier-select>
              </v-card-title>
              <v-card-text>
                <v-row v-for="receipt in receipts" class="mt-6">
                  <div class="card">
                    <div class="card__border"></div>
                    <div class="card_title__container">
                      <v-row>
                        <v-col cols="11">
                          <span class="card_title">ورودی {{ receipt.name }}</span>
                          <span v-if="receipt.driver_name" class="card__list">
                            تحویل گرفته از : {{ receipt.driver_name }}
                          </span>
                          <span v-if="receipt.enter_date" class="card__list">
                            در تاریخ : {{ receipt.enter_date }}
                          </span>
                          <span v-if="receipt.enter_time" class="card__list">
                            ساعت : {{ receipt.enter_time }}
                          </span>
                          <span v-if="receipt.box_count" class="card__list">
                            جمعا : {{ receipt.box_count }} کارتون
                          </span>
                          <span v-if="receipt.store_name" class="card__list">
                            به انبار : {{ receipt.store_name }}
                          </span>
                        </v-col>
                        <v-col cols="1">
                          <v-btn icon @click="show_items(receipt)">
                            <v-icon color="white">fa-bars</v-icon>
                          </v-btn>
                        </v-col>
                      </v-row>
                    </div>
                  </div>
                </v-row>
              </v-card-text>

            </v-row>
          </v-card>
        </v-hover>
      </v-col>


      <v-col cols="12" md="6">
        <m-datatable :show-filter-row="false" :headers="headers" :apiUrl="url" :filters.sync="filters"
                     ref="datatable" :show-select="false"
                     @dblclick:row="(e, row) => $router.push(to(row.item))"
        >
        </m-datatable>


      </v-col>
    </v-row>
    <v-row justify="center">
      <v-dialog
          v-model="items_dialog"
          class="rounded-lg"
          persistent
          @click:outside="items_dialog=false"
      >
        <v-card class="rounded-lg">
          <v-card-title class="secondary white--text" style="font-size: xx-small">
            <span class="card_title">ورودی {{ storeRes.name }}</span>
            <span v-if="storeRes.driver_name" class="mr-2">
                            تحویل گرفته از : {{ storeRes.driver_name }}
                          </span>
            <span v-if="storeRes.enter_date" class="mr-2">
                            در تاریخ : {{ storeRes.enter_date }}
                          </span>
            <span v-if="storeRes.enter_time" class="mr-2">
                            ساعت : {{ storeRes.enter_time }}
                          </span>
            <span v-if="storeRes.store_name" class="mr-2">
                            به انبار : {{ storeRes.store_name }}
                          </span>

          </v-card-title>
          <v-card-text class="pa-5">
            <v-row>
              <v-col cols="12" md="12">
                <v-simple-table>
                  <thead>
                  <tr class="white--text lightSecondary">
                    <th class="text-center white--text" style="font-size: x-small">
                      کد محصول
                    </th>
                    <th class="text-center white--text" style="font-size: x-small">
                      نام محصول
                    </th>
                    <th class="text-center white--text" style="font-size: x-small">
                      بارکد
                    </th>
                    <th class="text-center white--text" style="font-size: x-small">
                      تعداد کارتون
                    </th>
                    <th class="text-center white--text" style="font-size: x-small">
                      تعداد محصول در کارتون
                    </th>
                    <th class="text-center white--text" style="font-size: x-small">
                      تعداد خرابی
                    </th>
                    <th class="text-center white--text" style="font-size: x-small">
                      تعداد تولید محتوا
                    </th>
                    <th class="text-center white--text" style="font-size: x-small">
                      کد قفسه
                    </th>
                    <th class="text-center white--text" style="font-size: x-small">
                      قیمت فروش
                    </th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr v-for="item in items">
                    <td class="text-center">
                      {{item.product_code}}
                    </td>
                    <td class="text-center">
                      {{item.default_name}}
                    </td>
                    <td class="text-center">
                      {{item.barcode}}
                    </td>
                    <td class="text-center">
                      {{item.number_of_box | toMoney}}
                    </td>
                    <td class="text-center">
                      {{item.number_of_products_per_box | toMoney}}
                    </td>
                    <td class="text-center">
                      {{item.failure_count | toMoney}}
                    </td>
                    <td class="text-center">
                      {{content_production_count | toMoney}}
                    </td>
                    <td class="text-center">
                      {{item.new_product_shelf_code}}
                    </td>
                    <td class="text-center">
                      {{item.sale_price}}
                    </td>

                  </tr>
                  </tbody>
                </v-simple-table>

              </v-col>
            </v-row>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="error" text @click="items_dialog = false">
              بستن
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>


  </div>

</template>

<script>

import {MFormMixin} from "@/components/m-form";
import FormsMixin from "@/mixin/forms";
import {PathLevels, VisitorLevels} from "@/variables";
import formsMixin from "@/mixin/forms";
import money from "@/components/mcomponents/cleave/Money";
import Time from "@/components/mcomponents/cleave/Time";
import StoreSelect from "@/components/selects/StoreSelect";
import CurrencySelect from "@/components/selects/CurrencySelect";
import SupplierSelect from "@/components/selects/SupplierSelect";


export default {
  name: "SupplierStoreReceipts",
  components: {SupplierSelect, CurrencySelect, StoreSelect, Time},
  mixins: [MFormMixin, formsMixin, FormsMixin],
  props: {
    id: {},
  },
  data() {
    return {
      url: "main/supplier/all",
      filters: {},
      receipts: [],
      items: [],
      items_dialog: false,
      supplier: null,
      storeRes: {},
    };
  },
  computed: {
    title() {
      return 'محصولات های تحویل شده '
    },
    headers() {
      return [
        {
          text: "نام تامین کننده",
          value: "name",
        },
        {
          text: "ادمین",
          value: "admin_name",
        },

      ];
    },
  },
  updated() {
  },
  mounted() {
    if (this.id) {
      this.getReceipts()
      this.supplier = this.id
    }
  },
  watch: {
    id() {
      if (this.id) {
        this.packages = []
        this.supplier = this.id
        this.getReceipts()
      }
    },
    supplier() {
      this.id = this.supplier
    }
  },
  methods: {
    show_items(items) {
      this.items = items.items
      this.storeRes = items
      this.items_dialog = true
    },
    to(item) {
      return {
        name: "SupplierStoreReceipts",
        params: {
          id: item.id,
        },
      };
    },
    getReceipts() {
      this.request({
        url: this.endpoint(`entrance/supplierStoreReceipts/${this.id}`),
        method: "get",
        success: data => {
          this.receipts = data
        }
      })
    },
  },
}
</script>

<style scoped lang="scss">
.glass-effect {
  transition: backdrop-filter 0.5s ease;
  background-color: rgba(230, 230, 230, 0.2);
  backdrop-filter: blur(
          5px
  );
}

.glass-effect-hover {
  transition: backdrop-filter 0.5s ease;
  background-color: rgba(230, 230, 230, 0.2);
  backdrop-filter: blur(20px);
}

.cursor-pointer {
  cursor: pointer !important;
}

.card {
  --white: hsl(0, 0%, 100%);
  --black: hsl(240, 15%, 9%);
  --paragraph: hsl(0, 0%, 83%);
  --line: hsl(240, 9%, 17%);
  --primary: #e1ecf2;

  position: relative;

  display: flex;
  flex-direction: column;
  gap: 1rem;
  margin: auto;
  padding: 1rem;
  width: 90%;
  background-color: hsla(240, 15%, 9%, 1);
  background-image: radial-gradient(
          at 88% 40%,
          hsla(240, 15%, 9%, 1) 0px,
          transparent 85%
  ),
  radial-gradient(at 49% 30%, hsla(240, 15%, 9%, 1) 0px, transparent 85%),
  radial-gradient(at 14% 26%, hsla(240, 15%, 9%, 1) 0px, transparent 85%),
  radial-gradient(at 0% 64%, #0353A4 0px, transparent 85%),
  radial-gradient(at 41% 94%, #002855 0px, transparent 85%),
  radial-gradient(at 100% 99%, #001233 0px, transparent 85%);

  border-radius: 1rem;
  box-shadow: 0px -16px 24px 0px rgba(255, 255, 255, 0.25) inset;
}

.card .card__border {
  overflow: hidden;
  pointer-events: none;

  position: absolute;
  z-index: -10;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);

  width: calc(100% + 2px);
  height: calc(100% + 2px);
  background-image: linear-gradient(
          0deg,
          hsl(0, 0%, 100%) -50%,
          hsl(0, 0%, 40%) 100%
  );

  border-radius: 1rem;
}

.card .card__border::before {
  content: "";
  pointer-events: none;

  position: fixed;
  z-index: 200;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%), rotate(0deg);
  transform-origin: left;

  width: 200%;
  height: 10rem;
  background-image: linear-gradient(
          0deg,
          hsla(0, 0%, 100%, 0) 0%,
          #0353A4 40%,
          #002855 60%,
          hsla(0, 0%, 40%, 0) 100%
  );

  animation: rotate 8s linear infinite;
}

@keyframes rotate {
  to {
    transform: rotate(360deg);
  }
}

.card .card_title__container .card_title {
  font-size: 10px;
  color: var(--white);
}

.card .card_title__container .card_paragraph {
  margin-top: 0.25rem;
  width: 90%;

  font-size: 0.6rem;
  color: var(--paragraph);
}

.card .line {
  width: 100%;
  height: 0.1rem;
  background-color: var(--line);

  border: none;
}

.card .card__list {
  color: var(--white);
  font-size: 8px;
  margin-right: 10px;
}

.card .card__list .card__list_item {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.card .card__list .card__list_item .check {
  display: flex;
  justify-content: center;
  align-items: center;

  width: 1rem;
  height: 1rem;
  background-color: var(--primary);

  border-radius: 50%;
}

.card .card__list .card__list_item .check .check_svg {
  width: 0.75rem;
  height: 0.75rem;

  fill: var(--black);
}

.card .card__list .card__list_item .list_text {
  font-size: 0.55rem;
  color: var(--white);
}

.card .button {
  cursor: pointer;

  padding: 0.5rem;
  width: 100%;
  height: 100%;
  background-image: linear-gradient(
          0deg,
          #002855 0%,
          #0353A4 100%
  );

  font-size: 0.55rem;
  color: var(--white);

  border: 0;
  border-radius: 10px;
  box-shadow: inset 0 -2px 25px -4px var(--white);
}

</style>

